/* Chydee Premium — scroll-reveal + stagger animations */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;

  /* ── Observer factory ── */
  function makeObs(callback, options) {
    return new IntersectionObserver(callback, Object.assign(
      { threshold: 0.07, rootMargin: '0px 0px -48px 0px' },
      options || {}
    ));
  }

  /* ── Generic reveal observer ── */
  var revealObs = makeObs(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObs.unobserve(entry.target);
      }
    });
  });

  function revealEl(el, delayS) {
    if (!el) return;
    el.classList.add('chyd-reveal');
    if (delayS) el.style.transitionDelay = delayS + 's';
    revealObs.observe(el);
  }

  /* ── How-it-works: stagger steps when grid enters view ── */
  var gridObs = makeObs(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('.hiw__step').forEach(function (step, i) {
        step.classList.add('chyd-reveal');
        setTimeout(function () {
          step.classList.add('is-visible');
        }, i * 85 + 40);
      });
      gridObs.unobserve(entry.target);
    });
  }, { threshold: 0.04 });

  /* ── Testimonials: stagger cards when marquee-wrap enters view ── */
  var marqueeObs = makeObs(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealEl(entry.target.closest('.ctm') && entry.target.closest('.ctm').querySelector('.ctm__header'));
      marqueeObs.unobserve(entry.target);
    });
  }, { threshold: 0.06 });

  function init() {

    /* ── Trust bar inner ── */
    document.querySelectorAll('.ctb__inner').forEach(function (el) {
      revealEl(el, 0);
    });

    /* ── Feature bar: stagger each item ── */
    document.querySelectorAll('.cfs__item').forEach(function (el, i) {
      revealEl(el, i * 0.1);
    });

    /* ── How-it-works header + stagger grid ── */
    document.querySelectorAll('.hiw__header').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.hiw__grid').forEach(function (el) {
      gridObs.observe(el);
    });

    /* ── Testimonials header ── */
    document.querySelectorAll('.ctm__header').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.ctm__marquee-wrap').forEach(function (el) {
      marqueeObs.observe(el);
    });

    /* ── Photo gallery section ── */
    document.querySelectorAll('.media-guide__header').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.media-guide__grid').forEach(function (el) {
      revealEl(el, 0.12);
    });

    /* ── Final CTA container ── */
    document.querySelectorAll('.final-cta-container').forEach(function (el) {
      revealEl(el, 0);
    });

    /* ── Product hero: gallery fades in first, info side follows ── */
    document.querySelectorAll('.cph__gallery').forEach(function (el) {
      revealEl(el, 0);
    });
    document.querySelectorAll('.cph__info').forEach(function (el) {
      revealEl(el, 0.14);
    });

    /* ── Spec / About / Brand sections — reveal headers ── */
    [
      '.chydee-specs',
      '.chydee-about',
      '.chydee-brand-teaser',
      '.product-problem',
      '.chydee-safety-stats',
      '.chydee-vs-alternatives',
      '.chydee-contact',
      '.chydee-catalog-banner',
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (section) {
        /* Reveal all direct h2/h3/eyebrow-type children */
        var inner = section.querySelector('[class*="__inner"], [class*="__header"], [class*="__container"]');
        if (inner) revealEl(inner, 0);
      });
    });

    /* ── Lifestyle / press strips ── */
    document.querySelectorAll('.chydee-lifestyle-strip, .chydee-press-trust, .chydee-feature-strip').forEach(function (el) {
      revealEl(el, 0);
    });
  }

  /* Run after DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Mobile touch sparkle ── */
  var TOUCH_SEL = [
    '.chydee-hero__cta',
    '.about-promise__btn',
    '.chydee-chooser__card-btn',
    '.chooser-unlock-btn',
    '.cdb__btn',
    '.cpt__cta-btn',
    '.cbt__btn',
    '.chydee-lifestyle__btn',
    '.cbs__btn',
    '.cph__atc',
    '.final-cta-button',
    '.cph__price-badge--unlock',
    '.button',
    '[type="submit"]',
  ].join(',');

  document.addEventListener('touchstart', function (e) {
    if (window.matchMedia && window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) return;

    var btn = e.target && e.target.closest ? e.target.closest(TOUCH_SEL) : null;
    if (!btn) return;
    btn.classList.remove('cp-touched');
    void btn.offsetWidth; /* force reflow so animation restarts */
    btn.classList.add('cp-touched');
    setTimeout(function () { btn.classList.remove('cp-touched'); }, 640);
  }, { passive: true });

})();

/* Chydee — browser tab urgency copy */
(function () {
  'use strict';

  var activeTitle = document.title;
  var inactiveTitle = 'Sale Ends Soon';

  function updateTabTitle() {
    document.title = document.hidden ? inactiveTitle : activeTitle;
  }

  document.addEventListener('visibilitychange', updateTabTitle);
  window.addEventListener('pageshow', updateTabTitle);
  updateTabTitle();
})();

/* Chydee — real scratch card override (rectangular brush strokes, no circle eraser) */
(function () {
  'use strict';

  var PATCH_ID = 'cpop-real-scratch-canvas';
  var OPEN_PATCHED = false;

  function bootRealScratch() {
    setTimeout(initRealScratch, 90);
    patchOpenHandler();
  }

  function patchOpenHandler() {
    if (OPEN_PATCHED || typeof window.cpopOpen !== 'function') return;
    var originalOpen = window.cpopOpen;
    window.cpopOpen = function () {
      var result = originalOpen.apply(this, arguments);
      setTimeout(initRealScratch, 80);
      return result;
    };
    OPEN_PATCHED = true;
  }

  function initRealScratch() {
    var wrap = document.getElementById('cpop-scratch-wrap');
    var original = document.getElementById('cpop-scratch-canvas');
    if (!wrap || !original) return;

    var canvas = document.getElementById(PATCH_ID);
    if (canvas && canvas.__chydeeRealScratchReady) {
      canvas.__chydeeResize && canvas.__chydeeResize();
      return;
    }

    wrap.dataset.chydeeRealScratch = '1';
    wrap.style.position = 'relative';

    original.style.visibility = 'hidden';
    original.style.opacity = '0';
    original.style.pointerEvents = 'none';

    canvas = document.createElement('canvas');
    canvas.id = PATCH_ID;
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = [
      'position:absolute',
      'inset:0',
      'z-index:3',
      'display:block',
      'width:100%',
      'height:100%',
      'border-radius:10px',
      'touch-action:none',
      'cursor:grab',
      'transition:opacity .24s ease'
    ].join(';');

    var confetti = document.getElementById('cpop-confetti-wrap');
    if (confetti && confetti.parentNode === wrap) {
      wrap.insertBefore(canvas, confetti);
    } else {
      wrap.appendChild(canvas);
    }

    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return;

    var W = 0;
    var H = 0;
    var dpr = 1;
    var drawing = false;
    var revealed = false;
    var last = null;
    var seed = 7331;

    function rand() {
      seed = (seed * 1664525 + 1013904223) >>> 0;
      return seed / 4294967296;
    }

    function visibleSize() {
      var r = wrap.getBoundingClientRect();
      return {
        w: Math.max(0, Math.round(r.width || original.clientWidth || 0)),
        h: Math.max(0, Math.round(r.height || original.clientHeight || 0))
      };
    }

    function quietOriginalShimmer() {
      if (original.dataset.chydeeOriginalQuieted === '1') return;
      var r = original.getBoundingClientRect();
      if (!r.width || !r.height) return;
      original.dataset.chydeeOriginalQuieted = '1';
      try {
        original.dispatchEvent(new MouseEvent('mousedown', {
          bubbles: true,
          clientX: r.left + Math.min(6, r.width / 2),
          clientY: r.top + Math.min(6, r.height / 2)
        }));
        original.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
        original.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
      } catch (e) {}
    }

    function resize() {
      if (revealed) return true;
      var size = visibleSize();
      if (size.w < 40 || size.h < 40) {
        window.setTimeout(resize, 220);
        return false;
      }

      W = size.w;
      H = size.h;
      dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 2));
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      drawCover();
      quietOriginalShimmer();
      return true;
    }

    function drawCover() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, W, H);

      var foil = ctx.createLinearGradient(0, 0, W, H);
      foil.addColorStop(0, '#8F8B9C');
      foil.addColorStop(0.24, '#D9D7E0');
      foil.addColorStop(0.52, '#77738A');
      foil.addColorStop(0.78, '#F0EEF5');
      foil.addColorStop(1, '#858199');
      ctx.fillStyle = foil;
      ctx.fillRect(0, 0, W, H);

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      /* Rough diagonal foil grain — shaped like a real scratch card, not bubbles/circles. */
      ctx.globalAlpha = 0.36;
      for (var i = 0; i < 42; i++) {
        var y = rand() * (H + 38) - 19;
        var x = -W * 0.2 + rand() * W * 0.58;
        ctx.strokeStyle = i % 3 === 0 ? 'rgba(255,255,255,0.62)' : 'rgba(37,34,47,0.25)';
        ctx.lineWidth = 1 + rand() * 2.8;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x + W * (0.55 + rand() * 0.42), y - H * (0.22 + rand() * 0.26));
        ctx.stroke();
      }

      ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(13,13,13,0.52)';
      ctx.font = '800 14px system-ui, -apple-system, BlinkMacSystemFont, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH HERE', W / 2, H / 2);
    }

    function getPos(evt) {
      var r = canvas.getBoundingClientRect();
      var src = evt.touches && evt.touches.length ? evt.touches[0] : evt;
      return {
        x: (src.clientX - r.left) * (W / r.width),
        y: (src.clientY - r.top) * (H / r.height)
      };
    }

    function brushAt(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      var angle = -0.52;
      var cos = Math.cos(angle);
      var sin = Math.sin(angle);
      var normalX = -sin;
      var normalY = cos;

      /* Main dry-brush scratches: jagged diagonal strips, no ctx.arc circle eraser. */
      for (var i = 0; i < 14; i++) {
        var offset = (i - 6.5) * (2.7 + rand() * 1.45);
        var len = 40 + rand() * 62;
        var jitterX = (rand() - 0.5) * 13;
        var jitterY = (rand() - 0.5) * 10;
        var cx = x + normalX * offset + jitterX;
        var cy = y + normalY * offset + jitterY;
        var x1 = cx - cos * len * 0.5;
        var y1 = cy - sin * len * 0.5;
        var x2 = cx + cos * len * 0.5;
        var y2 = cy + sin * len * 0.5;

        ctx.globalAlpha = 0.68 + rand() * 0.32;
        ctx.lineWidth = 2.2 + rand() * 5.8;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.quadraticCurveTo(
          cx + (rand() - 0.5) * 18,
          cy + (rand() - 0.5) * 14,
          x2,
          y2
        );
        ctx.stroke();
      }

      /* Broken flecks/mini slashes to mimic the attached scratch-card texture. */
      for (var j = 0; j < 10; j++) {
        var shortLen = 9 + rand() * 26;
        var ox = (rand() - 0.5) * 76;
        var oy = (rand() - 0.5) * 42;
        var sx = x + ox;
        var sy = y + oy;
        ctx.globalAlpha = 0.45 + rand() * 0.36;
        ctx.lineWidth = 1.1 + rand() * 2.5;
        ctx.beginPath();
        ctx.moveTo(sx - cos * shortLen * 0.5, sy - sin * shortLen * 0.5);
        ctx.lineTo(sx + cos * shortLen * 0.5, sy + sin * shortLen * 0.5);
        ctx.stroke();
      }

      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }

    function scratchTo(p) {
      if (revealed || !W || !H) return;

      if (!last) {
        brushAt(p.x, p.y);
      } else {
        var dx = p.x - last.x;
        var dy = p.y - last.y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var steps = Math.max(1, Math.ceil(dist / 9));
        for (var i = 1; i <= steps; i++) {
          brushAt(last.x + dx * (i / steps), last.y + dy * (i / steps));
        }
      }

      last = p;

      if (checkProgress() > 0.34) reveal();
    }

    function checkProgress() {
      try {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var total = 0;
        var clear = 0;
        for (var i = 3; i < data.length; i += 16) {
          total++;
          if (data[i] < 72) clear++;
        }
        return total ? clear / total : 0;
      } catch (e) {
        return 0;
      }
    }

    function fireConfetti() {
      var confettiWrap = document.getElementById('cpop-confetti-wrap');
      if (!confettiWrap) return;
      var colors = ['#F5A623', '#FFD97D', '#FFFFFF'];
      for (var i = 0; i < 14; i++) {
        var span = document.createElement('span');
        span.className = 'cpop__confetti';
        span.style.background = colors[i % colors.length];
        span.style.setProperty('--cx', (Math.random() * 170 - 85) + 'px');
        span.style.setProperty('--cr', (Math.random() * 420) + 'deg');
        span.style.left = (44 + Math.random() * 12) + '%';
        confettiWrap.appendChild(span);
      }
      setTimeout(function () { confettiWrap.innerHTML = ''; }, 1250);
    }

    function reveal() {
      revealed = true;
      drawing = false;
      canvas.style.opacity = '0';
      canvas.style.pointerEvents = 'none';

      var prize = document.getElementById('cpop-scratch-prize');
      var hint = document.getElementById('cpop-scratch-hint');
      var coin = document.getElementById('cpop-coin');
      var claim = document.getElementById('cpop-scratch-claim');

      if (prize) prize.classList.add('is-shown');
      if (hint) hint.style.display = 'none';
      if (coin) coin.classList.remove('is-pulsing');
      if (claim) claim.disabled = false;

      fireConfetti();
    }

    function start(evt) {
      if (revealed) return;
      if (!W || !H) resize();
      evt.preventDefault();
      canvas.style.cursor = 'grabbing';
      drawing = true;
      last = null;
      scratchTo(getPos(evt));
    }

    function move(evt) {
      if (!drawing || revealed) return;
      evt.preventDefault();
      scratchTo(getPos(evt));
    }

    function end() {
      drawing = false;
      last = null;
      canvas.style.cursor = 'grab';
    }

    canvas.addEventListener('mousedown', start);
    window.addEventListener('mousemove', move, { passive: false });
    window.addEventListener('mouseup', end);
    canvas.addEventListener('touchstart', start, { passive: false });
    canvas.addEventListener('touchmove', move, { passive: false });
    canvas.addEventListener('touchend', end);
    canvas.addEventListener('touchcancel', end);

    canvas.__chydeeRealScratchReady = true;
    canvas.__chydeeResize = resize;

    resize();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { resize(); });
      ro.observe(wrap);
    }

    window.addEventListener('resize', resize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootRealScratch);
  } else {
    bootRealScratch();
  }

  document.addEventListener('shopify:section:load', bootRealScratch);
})();
